import React from "react";
import { usePage } from "@inertiajs/react";

export default function ParticipantUidHeading({
  newUid,
  oldUid,
  className = "text-2xl font-semibold",
}) {
  const { user } = usePage().props;
  const resolvedNew =
    newUid !== undefined ? newUid : user?.is?.currently_seeing_new;
  const resolvedOld =
    oldUid !== undefined ? oldUid : user?.is?.currently_seeing_old;
  const display = resolvedNew || resolvedOld;

  if (!display) {
    return null;
  }

  const showOld =
    Boolean(resolvedOld) && Boolean(resolvedNew) && resolvedOld !== resolvedNew;

  return (
    <div className="flex flex-row items-center gap-2">
      <p className={className}>{display}</p>
      {showOld && (
        <p className="text-sm font-normal text-gray-500">
          Old ID: {resolvedOld}
        </p>
      )}
    </div>
  );
}
